import { render, staticRenderFns } from "./CatalogSort.vue?vue&type=template&id=1463c215"
import script from "./CatalogSort.vue?vue&type=script&lang=js"
export * from "./CatalogSort.vue?vue&type=script&lang=js"
import style0 from "./CatalogSort.vue?vue&type=style&index=0&id=1463c215&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports